import { FormControl, ValidationErrors } from '@angular/forms';

export const checkairportValidator = (formControl: FormControl): ValidationErrors | null => {
    if (formControl.value instanceof Object) {
        return null;
    } else {
        return { incorrectSelectAirport: true };
    }
}
